export const formatPlanNumber = (num) => {
  if (num === 4) return "3A";
  if (num === 13) return "12A";
  if (num === 14) return "12B";

  if (num < 10) return `0${num}`;

  return String(num);
};

export const formatFloorLabel = (floorIndex) => {
  if (floorIndex === 0) return "Trệt";
  if (floorIndex === 4) return "3A";
  if (floorIndex === 13) return "12A";
  if (floorIndex === 14) return "12B";
  return floorIndex;
};

export const normalizeParams = (obj) => {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    result[key] = value === "" || value === "null" || value == null ? null : value;
  }

  return result;
};
